// extracted by mini-css-extract-plugin
module.exports = {"fuel-grade-column":"FuelGradeColumn_fuel-grade-column__3NvPF","confirm-cell":"FuelGradeColumn_confirm-cell__28vHw"};